import { render } from "./salesOverview.vue?vue&type=template&id=36d0ddfc"
import script from "./salesOverview.vue?vue&type=script&lang=js"
export * from "./salesOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__